"use client";

import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { Band, SectionHead } from "../ui/Section";
import Reveal from "../ui/Reveal";
import Icon from "../ui/Icon";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.kennybruce.cosebu";

const Marketplace = () => {
  const { t } = useLanguage();
  const featureIcons = ["search", "spark", "chat", "truck", "shield"];

  return (
    <Band id="marketplace" tint>
      <SectionHead
        index={3}
        label={t.marketplace.eyebrow}
        title={t.marketplace.title}
        action={
          <div className="flex flex-wrap items-center gap-3">
            <RouterLink to="/downloads" className="btn btn--primary">
              {t.marketplace.download}
              <Icon name="arrowRight" size={16} />
            </RouterLink>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--secondary"
            >
              <Icon name="google" size={15} />
              Google Play
            </a>
          </div>
        }
      >
        {t.marketplace.description}
      </SectionHead>

      <div className="rail">
        <div className="rail__label" aria-hidden="true" />

        <div className="grid items-start gap-12 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-6">
            <ul className="divide-rule border-t border-line">
              {t.marketplace.features.map((feature, index) => (
                <Reveal
                  as="li"
                  key={feature}
                  delay={index * 0.04}
                  className="flex items-center gap-3.5 py-4"
                >
                  <Icon
                    name={featureIcons[index]}
                    size={18}
                    className="flex-none text-accent"
                  />
                  <span className="text-[15px]">{feature}</span>
                </Reveal>
              ))}
            </ul>

            <Reveal delay={0.2} className="mt-8">
              <p className="meta max-w-[42ch]">{t.downloads.iosNote}</p>
            </Reveal>
          </div>

          {/* Device frame: plain bezel, real screenshot, no floating badges. */}
          <Reveal delay={0.08} className="lg:col-span-6">
            <div className="mx-auto w-full max-w-[280px]">
              <div className="rounded-[30px] border border-line-strong bg-surface p-2 shadow-raise">
                <div className="overflow-hidden rounded-[22px] border border-line bg-surface-2">
                  <img
                    src="/marketplace-app.jpg"
                    alt={`${t.marketplace.title} — mobile app`}
                    loading="lazy"
                    className="w-full"
                  />
                </div>
              </div>
              <p className="eyebrow mt-4 text-center">COSEBU Marketplace · Android</p>
            </div>
          </Reveal>
        </div>
      </div>
    </Band>
  );
};

export default Marketplace;
